import { Injectable } from '@angular/core';
import { DprProgressDetail, ProgressStockDetails } from '@shared/models/dpr';

@Injectable()
export class ProgressStockService {
  /**
   * @description Updates stock details for a day based on changes from the previous day
   */
  onPreviousDayChanged(
    previousDayProgressStockDetails: ProgressStockDetails,
    targetTotal: number,
    dprProgressDetails?: DprProgressDetail,
    progressStockDetails?: ProgressStockDetails
  ): ProgressStockDetails {
    progressStockDetails = progressStockDetails || {};

    progressStockDetails.clearedTotal = this.calculateClearedTotal(
      previousDayProgressStockDetails?.clearedTotal,
      dprProgressDetails?.clearedToday
    );
    progressStockDetails.totalLeft = this.calculateTotalLeft(
      targetTotal,
      previousDayProgressStockDetails?.clearedTotal,
      dprProgressDetails?.clearedToday
    );
    progressStockDetails.percentComplete = this.calculatePercentComplete(
      targetTotal,
      previousDayProgressStockDetails?.clearedTotal,
      dprProgressDetails?.clearedToday
    );

    return progressStockDetails;
  }

  calculateClearedTotal(
    totalClearedBefore: number,
    clearedToday: number
  ): number {
    return (totalClearedBefore || 0) + (clearedToday || 0);
  }

  calculateTotalLeft(
    targetTotal: number,
    totalClearedBefore: number,
    clearedToday: number
  ): number {
    return (
      (targetTotal || 0) -
      (this.calculateClearedTotal(totalClearedBefore, clearedToday) || 0)
    );
  }

  calculatePercentComplete(
    targetTotal: number,
    totalClearedBefore: number,
    clearedToday: number
  ): number {
    return Math.round(
      ((this.calculateClearedTotal(totalClearedBefore, clearedToday) || 0) /
        (targetTotal || 0)) *
        100
    );
  }
}
